import { render, staticRenderFns } from "./ImgItem.vue?vue&type=template&id=28631a90"
import script from "./ImgItem.vue?vue&type=script&lang=js"
export * from "./ImgItem.vue?vue&type=script&lang=js"
import style0 from "./ImgItem.vue?vue&type=style&index=0&id=28631a90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports